// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__pfMMv","dot":"preloader_dot__iYFog","sk-bounce":"preloader_sk-bounce__76yro"};